<template>
  <button class="active_btn" @click.stop="handleLike">
    <img
      :src="src"
      class="active_icon"
      loading="lazy"
      :class="{ animate: isLikeAnimating }"
    />
    <p :class="{ animate: isLikeAnimating }">{{ qty }}</p>
  </button>
</template>

<script>
import { usePostActions } from "@/composables/usePostActions";

export default {
  name: "LikeBtn",
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLikeAnimating: false,
      sendLike: usePostActions(this.post).sendLike,
    };
  },
  methods: {
    async handleLike() {
      if (this.isLikeAnimating) return;

      this.isLikeAnimating = true;

      await this.sendLike();

      setTimeout(() => {
        this.isLikeAnimating = false;
      }, 300);
    },
  },
  computed: {
    src() {
      return this.post.is_liked ? "/Like-filled.svg" : "/Like.svg";
    },
    qty() {
      return this.post.likes_qty || 0;
    },
  },
};
</script>

<style>
.active_btn {
  display: flex;
  align-items: center;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  font-size: 14px;
  padding: 6px 14px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  transition: all var(--transition-time) ease;
}

.active_btn.active {
  background-color: rgba(255, 255, 255, 0.35);
}

.active_btn:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.active_btn p {
  margin: 0;
}

.active_icon {
  width: 25px;
  height: 22px;
  margin-right: 6px;
}

.active_icon.animate {
  animation: likePop 0.3s ease;
}

p.animate {
  animation: likePop 0.3s ease;
}

@keyframes likePop {
  0% {
    transform: scale(1);
  }

  30% {
    transform: scale(1.2);
  }

  60% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}
</style>
